const VISITOR_ID_KEY = 'aiChatVisitorId'
const VALID_SOURCE_TYPES = ['selection', 'paragraph']

function getStorage (storage) {
  if (storage) return storage
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage
  }
  return null
}

function defaultVisitorId () {
  return 'guest-' + Date.now() + '-' + Math.random().toString(16).slice(2)
}

export function getTranslationIdentity (storage, createVisitorId) {
  var targetStorage = getStorage(storage)
  var isUser = targetStorage &&
    targetStorage.getItem('isLogined') === 'true' &&
    targetStorage.getItem('userName') !== 'anonymity'
  var rawUserId = targetStorage && targetStorage.getItem('userId')
  var userId = Number(rawUserId)

  if (isUser && rawUserId && !isNaN(userId)) {
    return {
      userId: userId
    }
  }

  var visitorId = targetStorage && targetStorage.getItem(VISITOR_ID_KEY)
  if (!visitorId) {
    visitorId = (createVisitorId || defaultVisitorId)()
    if (targetStorage) {
      targetStorage.setItem(VISITOR_ID_KEY, visitorId)
    }
  }
  return {
    visitorId: visitorId
  }
}

export function buildTranslatePayload (options, storage, createVisitorId) {
  var text = options && options.text ? String(options.text).trim() : ''
  if (!text) {
    throw new Error('翻译文本不能为空')
  }
  if (text.length < 2) {
    throw new Error('翻译文本过短，至少需要2个字符')
  }
  if (text.length > 5000) {
    throw new Error('翻译文本不能超过5000字')
  }

  var sourceType = options.sourceType || 'selection'
  if (VALID_SOURCE_TYPES.indexOf(sourceType) === -1) {
    throw new Error('sourceType只能为selection或paragraph')
  }

  var payload = {
    text: text,
    sourceType: sourceType
  }
  if (options.bookId !== undefined && options.bookId !== null && String(options.bookId) !== '') {
    payload.bookId = String(options.bookId)
  }

  var identity = getTranslationIdentity(storage, createVisitorId)
  if (identity.userId) {
    payload.userId = identity.userId
  } else {
    payload.visitorId = identity.visitorId
  }
  return payload
}

export function parseTranslateResponse (res) {
  if (!res || res.status !== 200) {
    throw new Error('翻译失败，请稍后重试')
  }
  var body = res.data || {}
  if (body.status !== 200) {
    throw new Error(body.message || '翻译失败，请稍后重试')
  }
  var data = body.data || {}
  return {
    originalText: data.originalText || '',
    translatedText: data.translatedText || '',
    model: data.model || '',
    totalTokens: data.totalTokens || 0,
    latencyMs: data.latencyMs || 0
  }
}

export function getTranslateErrorMessage (error, fallback) {
  if (error && error.data && error.data.message) {
    return error.data.message
  }
  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message
  }
  if (error && error.message) {
    return error.message
  }
  return fallback || '翻译失败，请稍后重试'
}



// WEBPACK FOOTER //
// ./src/utils/aiTranslate.js